// resources/js/Snowfall.js
import {LetItGo} from "let-it-go";

class Snowfall {
    constructor() {
        if (this.shouldShowSnow()) {
            this.snow = new LetItGo({
                root: document.querySelector("body"),
                style: { zIndex: 15000, pointerEvents: "none" },
                number: 1000,
                velocityXRange: [-3, 3],
                velocityYRange: [1, 5],
                radiusRange: [2, 5],
                color: "#eeeeee",
                alphaRange: [0.8, 1],
                backgroundColor: "transparent",
            });
        }
    }

    shouldShowSnow() {
        const today = new Date();
        const start = new Date(today.getFullYear(), 10, 1); // December 1st
        const end = new Date(today.getFullYear() + 1, 0, 15); // January 15th

        return today >= start && today <= end;
    }
}

export default Snowfall;